import { goodsPromoteStatusArr } from '@/utils/newDataMap/shopManage';
export const configList = [
	{
		label: '推广状态',
		key: 'status',
		type: 'select',
		placeholder: '请选择',
		options: goodsPromoteStatusArr,
		isShow: true,
		clearable: true,
		filterable: true,
		multiple: false,
	},
	{
		label: '团长',
		key: 'authorityId',
		type: 'component',
		component: () => import('@/components/commanderSelect/index.vue'),
		isShow: true,
	},
];
